import { type LoaderFunctionArgs, redirect } from 'react-router';
import ROUTES from '@/routes';
import { useMessageStore } from '@/stores/message';

export async function mediaMessageByIdLoader({ params, request }: LoaderFunctionArgs) {
  const { id, messageId } = ROUTES.MESSAGES.SESSIONS.MEDIA.BY_ID.$deserializeParams(params);

  if (!useMessageStore.getState().messages.has(messageId)) {
    return redirect(
      (request.url.includes('groups') ? ROUTES.MESSAGES.GROUPS : ROUTES.MESSAGES.SESSIONS).$buildPath({
        params: { id },
      }),
    );
  }

  return {};
}
